module.exports = __webpack_public_path__ + "static/img/DoAqPlCV4AA6Yw1.5f2f6ea.jpg";